import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
// import styled from 'styled-components'

import { useTranslation } from 'i18n-web/i18next'
import { setParkingCode } from 'redux-web/utils/payBySignage/actions'
// import Tooltip from 'components/Atoms/Tooltip'
// import Text from 'components/Atoms/Text'

import BasicTextField from '../../../Form/BasicTextField'

// const TooltipText = styled(Text)`
//   margin-bottom: 5px;
// `

const ParkingCode = ({ parkingCodeRef }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { parkingCode } = useSelector(state => state.payBySignage)

  const [value, setValue] = useState(parkingCode)

  useEffect(() => {
    dispatch(setParkingCode(value))
  }, [value])

  const onChange = value => {
    setValue(value)
  }

  return (
    <>
      <BasicTextField
        label={t('payBySignage.parkingCode.label')}
        value={value}
        isRequired={false}
        name={'parkingCode'}
        inputRef={parkingCodeRef}
        validateOnFocus={true}
        onChange={onChange}
      />

      {/* <Tooltip title={t('payBySignage.parkingCode.tooltip.title')}>
        <TooltipText className="tiny semiBold">
          {t('payBySignage.parkingCode.tooltip.description')}
        </TooltipText>
      </Tooltip> */}
    </>
  )
}

ParkingCode.propTypes = {
  parkingCodeRef: PropTypes.object,
}

export default ParkingCode
